export default import.meta.ROLLUP_FILE_URL_DBIT5LFp